
export const CUSTOMER_ADDRESSES_LOADING = 'REDUX_SAGA_CUSTOMER_ADDRESSES_LOADING';
export const CUSTOMER_ADDRESSES_SUCCESS = 'REDUX_SAGA_CUSTOMER_ADDRESSES_SUCCESS';
export const CUSTOMER_ADDRESSES_ERROR = 'REDUX_SAGA_CUSTOMER_ADDRESSES_ERROR';
export const RESET_CUSTOMER_ADDRESSES = 'REDUX_SAGA_RESET_CUSTOMER_ADDRESSES';

export const actionGetCustomerAddresses = (dispatch, customerIdList) => {
    dispatch({ type: CUSTOMER_ADDRESSES_LOADING, customerIdList: customerIdList });
};

export const actionResetCustomerAddresses = (dispatch) => {
    dispatch({ type: RESET_CUSTOMER_ADDRESSES })
};
